//export const API_URL = 'http://localhost:9000/';
export const API_URL = 'https://api.time.i2a.no/';
